import { Contact } from "../types";

class ContactStore {
    private _contact: Contact = {} as Contact;

    set contact(contact_: Contact) {
        this._contact = contact_;
    }

    get contact(): Contact {
        return this._contact;
    }
}

export const contactStore = new ContactStore();